module.exports = __webpack_public_path__ + "static/media/zoom.51483003.svg";